var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 47 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C93F36",
    fillRule: "evenodd",
    d: "M23.5 39.5V4.934a12.6 12.6 0 0 0-3.734-3.155A12.9 12.9 0 0 0 14.823.223c-1.74-.18-3.5-.008-5.17.505a12.8 12.8 0 0 0-4.526 2.48 12.4 12.4 0 0 0-3.125 4.037 12.037 12.037 0 0 0-.268 9.89 12.3 12.3 0 0 0 2.902 4.191z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC929E",
    fillRule: "evenodd",
    d: "M23.5 39.5V4.934a12.6 12.6 0 0 1 3.733-3.155A12.9 12.9 0 0 1 32.177.223c1.74-.18 3.5-.008 5.169.505a12.8 12.8 0 0 1 4.527 2.48 12.4 12.4 0 0 1 3.124 4.037 12.037 12.037 0 0 1 .268 9.89 12.3 12.3 0 0 1-2.902 4.191z",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;